import { render, staticRenderFns } from "./LiveEditText.ts.vue?vue&type=template&id=a15c5e24"
import script from "./LiveEditText.ts.vue?vue&type=script&lang=ts"
export * from "./LiveEditText.ts.vue?vue&type=script&lang=ts"
import style0 from "./LiveEditText.ts.vue?vue&type=style&index=0&id=a15c5e24&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports